import { commentItems } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 bg-secondary-100 text-secondary-700 text-xs font-semibold px-3 py-1 rounded-full mb-4">
            <i className="ri-chat-smile-2-line text-sm"></i>
            热议评论
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground-950 font-heading mb-3">
            瓜友热评
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            百万吃瓜群众的真实声音，看看大家怎么评价这些热点事件
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {commentItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-2xl p-5 border border-background-200"
            >
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 flex-shrink-0 rounded-full overflow-hidden">
                  <img
                    src={item.avatar}
                    alt={item.nickname}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-0.5">
                    <span className="text-foreground-950 text-sm font-bold whitespace-nowrap">{item.nickname}</span>
                    <span className={`text-xs font-medium px-1.5 py-0.5 rounded ${
                      item.tag === '热门' ? 'bg-primary-100 text-primary-600' :
                      item.tag === '精选' ? 'bg-accent-100 text-accent-600' :
                      item.tag === '大神' ? 'bg-accent-100 text-accent-600' :
                      'bg-secondary-100 text-secondary-600'
                    }`}>{item.tag}</span>
                  </div>
                  <span className="text-foreground-400 text-xs">{item.time}</span>
                </div>
              </div>
              <p className="text-foreground-700 text-sm leading-relaxed mb-3">
                {item.content}
              </p>
              <div className="flex items-center gap-4 text-foreground-400 text-xs">
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-thumb-up-line"></i>
                  {item.likes}
                </span>
                <span className="cursor-pointer hover:text-foreground-600 transition-colors">
                  <i className="ri-chat-3-line mr-1"></i>回复
                </span>
                <span className="cursor-pointer hover:text-foreground-600 transition-colors">
                  <i className="ri-share-forward-line mr-1"></i>分享
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}